<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <div v-if="isVisible" class="wrapper">
      <v-card>
        <v-card-title>
          <span class="headline">Add New Twilio Number</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select v-model="field.phoneType"
                          :items="allPhoneTypes"
                          item-text="label"
                          item-value="value"
                          label="Select Phone Type" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="field.zipCode"
                              required
                              type="number"
                              :rules="[rules.required, rules.counter]"
                              label="Zip Code (5 Digit) *" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="a-center">
                <v-btn color="primary"
                       depressed
                       :disabled="field.zipCode.length === 0 || field.zipCode.length > 5"
                       @click="fetchNumbers">
                  Fetch Available Numbers
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="fetchedNumbers.length > 0 && isFetched">
              <v-col cols="12" class="a-center">
                <h4>Availble Numbers</h4>
              </v-col>
            </v-row>
            <v-row v-if="fetchedNumbers.length === 0 && isFetched">
              <v-col cols="12" class="a-center">
                <h4>No Numbers Availble</h4>
              </v-col>
            </v-row>
            <v-row v-if="fetchedNumbers.length > 0 && isFetched">
              <v-col cols="12" class="phoneNumbersWrapper">
                <div v-for="number in fetchedNumbers"
                     :key="number.PhoneNumber"
                     @click="updatePhoneNumber(number)">
                  <v-checkbox v-model="number.isSelected"
                              class="numberCheckBox"
                              :label="number.friendly_name" />
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="actionBar">
          <v-spacer />
          <v-btn color="secondary" text @click="close"> Cancel </v-btn>
          <v-btn v-if="isFetched" color="primary" text @click="submit">
            Add Number
          </v-btn>
        </v-card-actions>
        <v-snackbar v-model="snackbar">
          {{ notification }}

          <template v-slot:action="{ attrs }">
            <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
  import { VueMaskDirective } from "v-mask";
  import Vue from "vue";
  import Api from "../../../shared-module/api";

  Vue.directive("mask", VueMaskDirective);

  export default {
    name: "AddTwilioNumber",
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      isEditMode: {
        type: Boolean,
        default: false
      },
      selectedMessagingService: {
        type: Object,
        default: null
      },
      selectedClinic: {
        type: Object,
        default: null
      }
    },
    data: () => ({
      username: null,
      snackbar: false,
      field: {
        phoneType: "",
        zipCode: "",
        selectedNumber: ""
      },
      selectedNumbers: {},
      allPhoneTypes: [
        {
          label: "Local",
          value: 1
        },
        {
          label: "Toll Free",
          value: 2
        },
        {
          label: "Mobile",
          value: 3
        }
      ],
      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 5 || "Max 5 characters"
      },
      fetchedNumbers: [],
      isFetched: false,
      isFormDirty: false
    }),

    watch: {
      isVisible(val) {
        if (val) {
          this.isFormDirty = false;
          // Dialog opened
          // Reset all fields
          this.field = Object.assign({
            phoneType: "",
            zipCode: "",
            selectedNumber: ""
          });
          this.fetchedNumbers = [];
          this.isFetched = false;
          this.selectedNumbers = [];
        }
      }
    },

    created() {
      this.username = localStorage.getItem("username");
    },

    methods: {
      close() {
        this.$emit("on-close");
      },

      isSearchValid() {
        return !!(this.field.phoneType && this.field.zipCode);
      },

      updatePhoneNumber(number) {
        console.log("number :>> ", number);
        if (this.selectedNumbers[number.phone_number]) {
          delete this.selectedNumbers[number.phone_number];
        } else {
          this.selectedNumbers[number.phone_number] = true;
        }
      },

      async fetchNumbers() {
        try {
          this.fetchedNumbers = [];
          this.isFetched = false;
          this.field.selectedNumber = "";

          this.$emit("on-submit");
          console.log('this.selectedClinic', this.selectedClinic);

          const { data } = await Api.messagingService.private.getAvailableTwilioNumbers({
            practiceId: this.selectedClinic.Practice_ID,
            phoneType: this.field.phoneType,
            zipCode: this.field.zipCode
          });

          console.log('Available Twilio Numbers ', data);

          this.$emit("on-spinner-hide");

          if (data && data.length > 0) {
            // eslint-disable-next-line radix
            this.fetchedNumbers = data.map(number => ({
              ...number,
              phone_number: number.PhoneNumber,
              friendly_name: number.Name,
              isSelected: false
            }));
          }
          this.isFetched = true;
        } catch (error) {
          console.log("error :>> ", error);
          this.$emit("on-spinner-hide");
          this.isFetched = true;
        }
      },

      isFormValid() {
        this.notification = "";
        if (!this.field.name || !this.field.name.length) {
          this.notification = "Fill all the required fields";
          return false;
        }
        if (!this.field.number || !this.field.number.length) {
          this.notification = "Provide a valid 10 digit cell number";
          return false;
        }
        return true;
      },

      _mergeNumbers() {
        let mergedNumbers = "";
        Object.keys(this.selectedNumbers).forEach((number, index) => {
          if (index > 0) {
            mergedNumbers += ";";
          }
          mergedNumbers += number;
        });
        return mergedNumbers;
      },

      async submit() {
        this.isFormDirty = true;
        if (!Object.keys(this.selectedNumbers).length) {
          this.snackbar = true;
          this.notification = "Please select a phone number";
        } else {
          this.$emit("on-submit");
          const mergedNumbers = this._mergeNumbers();
          try {
            await Api.messagingService.private.provisionTwilioNumber({
              PhoneNumber: mergedNumbers,
              PracticeID: this.selectedClinic.Practice_ID, // integer
              Name: this.selectedClinic.Company // Make it name of clinic
            });
            // await Api.messagingService.private.addTwilioNumber({
            //   PhoneNumber: mergedNumbers,
            //   SenderName: this.selectedClinic.company, //  user companyName,
            //   PracticeID: this.selectedClinic.practice_ID,
            // });
            this.$emit("on-success");
            this.fetchNumbers();
          } catch (error) {
            this.$emit("on-error", error);
          }
        }
      }
    }
  };
</script>

<style scoped>
  .a-center {
    text-align: center;
  }

  .phoneNumbersWrapper {
    max-height: 250px;
    overflow-y: scroll;
  }

  .actionBar {
    /*position: absolute;*/
    bottom: 0;
    right: 0;
    height: 80px;
    padding-bottom: 25px;
    background-color: white;
  }

  .wrapper {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
